// Обозначения токенов приведены к требованиям по задаче
export const TOKENS = {
  R: {
    pattern: /[IVXLC1УХЛС]/,
  },
  0: {
    pattern: /[0-9]/,
  },
  9: {
    pattern: /[0-9]/,
  },
  Б: {
    pattern: /[А-ЯЁё]/,
  },
  S: {
    pattern: /[А-яA-z0-9]/,
  },
  T: {
    pattern: /[ЁёА-Яа-я -]/,
    transform: (v: any) => {
      return v.toLocaleLowerCase();
    },
  },
  F: {
    pattern: /[А-яЁё]/,
    transform: function (v: any) {
      return v.toLocaleUpperCase();
    },
  },
  K: {
    pattern: /[0-9a-zA-Z]/,
    transform: (v: string) => v.toLocaleUpperCase(),
  },
  G: {
    pattern: /[0-9a-f]/,
  }
};

export default function hints(mask: string) {
  const legend = new Map();
  legend.set(
    'R',
    'R - римское число, заданное символами ""I"", ""V"", ""X"", ""L"", ""C"", набранными на верхнем регистре латинской клавиатуры;'
  );
  legend.set('9', '9 - любая десятичная цифра (обязательная);');
  legend.set(
    '0',
    '0 - любая десятичная цифра (необязательная, может отсутствовать);'
  );
  legend.set('Б', 'Б - любая русская заглавная буква;');
  legend.set(
    'S',
    'S - символ не контролируется (может содержать любую букву, цифру или вообще отсутствовать);'
  );
  const maskSet = new Set(
    mask.split('').filter((item) => item !== '-' && item !== ' ')
  );
  const arrHint = [];
  for (let value of maskSet) {
    arrHint.push(legend.get(value));
  }

  return arrHint;
}
